$( document ).on("turbo:load", initUserDetails);

function initUserDetails() {
    bindUserAccountDetails();
    $('#filter_shared_with_button').on('click', function (e) {
        var $contentId = $('#shared_with').val();
        $.get(document.location.href + '.js', $contentId === '' ? null : {content_id: $contentId}, function(){
            bindUserAccountDetails();});
    });
}

function getUserAccountDetails(url, id) {
    var data = {id: id};
    $.get(url, data, function(data) {
        $("#user-account-details-modal .modal-body").replaceWith(data['user_account']);
        $("#user-account-details-modal").modal("show");
    });
}

function bindUserAccountDetails(){
    $('.open-user-account-details').on('click', function(event){
        event.preventDefault();
        var $userAccountID = $(this).data('id');
        var $url = $(this).data('url');
        getUserAccountDetails($url, $userAccountID);
    });
}
